import { __assign, __decorate, __metadata } from "tslib";
import { NoTracking, Observable } from './Decorators';
import { JSFormatter } from '../Data/Serialiser';
import { NeoTypeInfo } from './NeoTypeInfo';
import { Utils } from '../Utils';
import { SerialiseType } from './Misc';
var BindableBase = /** @class */ (function () {
    function BindableBase() {
        this.entityIdentifier = Utils.uuidv4();
    }
    /**
     * Converts a plain javascript object graph to a neo model graph.
     * Replaces child lists - Items in the child list, but not in jsArray will be removed.
     * If you need missing items to remain, use update() instead.
     * This will generally be used after calling toJSObject(includeClean = true)
     * */
    BindableBase.prototype.set = function (jsObject, options) {
        JSFormatter.deserialise(jsObject, this, null, __assign({ removeOldItems: true }, options));
    };
    /**
     * Copies the provided objects properties into this objects properties. Matches on name.
     * Syncs child lists by default unless configured in the options argument.
     */
    BindableBase.prototype.mapFrom = function (object, options) {
        JSFormatter.deserialise(object, this, null, __assign({ removeOldItems: true, isMap: true }, options));
        return this;
    };
    /**
     * Performs a deep clone on an object. Equivalent to Type.mapFrom(this).
     */
    BindableBase.prototype.clone = function () {
        return this.constructor.mapFrom(this);
    };
    /**
     * Called once a deserialise batch has completed.
     */
    BindableBase.prototype.onDeserialiseCompleted = function (wasCreated) {
    };
    /**
     * Makes the model observable and creates its 'meta' object.
     * Must be called in the constructor, preferably directly after the super() call.
     * This method can be used as an alternative to the @NeoModel decorator.
     */
    BindableBase.prototype.makeObservable = function (options) {
        var _a;
        options !== null && options !== void 0 ? options : (options = {});
        (_a = options.makeObservable) !== null && _a !== void 0 ? _a : (options.makeObservable = true);
        this.makeBindable(options);
    };
    /**
     * Makes the model bindable (and observable if it inherits from ModelBase) by creating its 'meta' object.
     * Must be called in the constructor, preferably directly after the super() call.
     * This method can be used as an alternative to the @NeoModel decorator.
     */
    BindableBase.prototype.makeBindable = function (options) {
        NeoTypeInfo.makeObservable(this, options);
    };
    /**
     * Creates a new instance of this type, and deserialises the plain javascript object graph into it.
     * @param jsObject Plain js object
     */
    BindableBase.fromJSObject = function (jsObject, options) {
        var newItem = Utils.createInstance(this);
        JSFormatter.deserialise(jsObject, newItem, null, __assign({ removeOldItems: true }, options), true);
        return newItem;
    };
    BindableBase.mapFrom = function (object, options) {
        var newItem = Utils.createInstance(this);
        JSFormatter.deserialise(object, newItem, null, __assign({ removeOldItems: true, isMap: true }, options), true);
        return newItem;
    };
    __decorate([
        NoTracking(SerialiseType.Never),
        Observable(false),
        __metadata("design:type", Object)
    ], BindableBase.prototype, "meta", void 0);
    __decorate([
        NoTracking(SerialiseType.Never),
        __metadata("design:type", Object)
    ], BindableBase.prototype, "entityIdentifier", void 0);
    return BindableBase;
}());
export { BindableBase };
